import React, { FC } from 'react';
import {
  Text,
  Box,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalSize,
  ButtonAppearance,
  Button,
  ModalClose,
} from '@bechtel/gds';
import { ApolloError } from '@apollo/client';
import { t, Trans } from '@lingui/macro';
import { RejectWeldErrorProps } from './types';
import { RejectFitupError, RejectWeldError } from '@bechtel/types';

const getErrorMessage = (error: RejectWeldErrorProps['error']) => {
  if (error instanceof ApolloError) {
    return <Trans>Network error has occured.Please close button and try again.</Trans>;
  }
  switch (error) {
    case RejectWeldError.MILESTONE_NOT_CLAIMED:
      return <Trans>Milestone is not claimed.</Trans>;
    case RejectWeldError.EIS_ERROR:
      return <Trans>EIS error.</Trans>;
    case RejectWeldError.MISSING_COMMENTS:
      return <Trans>Missing Comments.</Trans>;
    case RejectWeldError.REJECT_WELD_MILESTONE_ERRORED:
      return <Trans>Reject weld errored.</Trans>;
    case RejectFitupError.REJECT_FITUP_MILESTONE_ERRORED:
      return <Trans>Reject Fitup errored.</Trans>;
    case RejectWeldError.MILESTONE_CONFIG_NOT_FOUND:
      return <Trans>Milestone config not found.</Trans>;
    case RejectWeldError.MILESTONE_IS_APPROVED:
      return <Trans>Milestone is approved.</Trans>;
    case RejectWeldError.MILESTONE_IS_BLOCKED:
      return <Trans>Milestone is blocked.</Trans>;
    case RejectWeldError.MILESTONE_IS_REJECTED:
      return <Trans>Milestone is rejected.</Trans>;
    case RejectWeldError.MISSING_REQUIRED_PERMISSION:
      return <Trans>Missing required permission.</Trans>;
    case RejectWeldError.NOT_FOUND:
      return <Trans>Not Found.</Trans>;
    case RejectWeldError.SERVICE_PROXY_ERROR:
      return <Trans>Server proxy error.</Trans>;
    default:
      return <Trans>An error has occured. Please click close button and try again.</Trans>;
  }
};

export const RejectWeldErrorModal: FC<RejectWeldErrorProps> = ({ error, close }) => {
  return (
    <Modal visible size={ModalSize.DEFAULT} style={{ width: '400px', height: '275px' }}>
      <ModalHeader title={t`Reject Weld Error`}>
        <ModalClose onClick={close}></ModalClose>
      </ModalHeader>
      <ModalBody>
        <Box p={{ sm: '500' }}>
          <Text size="500">{getErrorMessage(error)}</Text>
        </Box>
      </ModalBody>
      <ModalFooter>
        <Box justifyContent={{ sm: 'flex-end' }}>
          <Box mr={{ sm: '400' }}>
            <Button appearance={ButtonAppearance.SECONDARY} onClick={close}>
              <Trans> Close</Trans>
            </Button>
          </Box>
        </Box>
      </ModalFooter>
    </Modal>
  );
};
